import {
  useQuery, useQueryClient, UseQueryResult, useMutation,
} from '@tanstack/react-query';
import { getDeviceDetailsLocations, getDeviceDetailsLocationsByIds } from '../../services/MapsService';
import { LocationDetailsResponse } from '../../types/Maps';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDeviceLocations(
  fleetId: string,
  query: string,
  id: string,
  refetch = true,
): UseQueryResult<LocationDetailsResponse> {
  return useQuery(
    ['deviceLocations', fleetId, id, query],
    async (): Promise<LocationDetailsResponse> => getDeviceDetailsLocations(fleetId, id, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: refetch ? FeaturesManagement.productivity.refetchInterval : false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!id,
    },
  );
}

export function useGetDeviceLocationsByIds(
  successCb: (args: LocationDetailsResponse[]) => void,
  failureCb: (error: string) => void,
): LocationDetailsResponse {
  const queryClient = useQueryClient();

  return useMutation(getDeviceDetailsLocationsByIds, {
    onSuccess: (data) => {
      successCb(data);
      queryClient.invalidateQueries({ queryKey: ['deviceLocationsByIds'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useGetDeviceLocations;
